export const uploadToCloudinary = async (pics:any) => {

    // const cloud_name="dxoqwusir"
    const cloud_name="dotmiskas"
    
    
    if (pics) {
      
      const data = new FormData();
      data.append("file", pics);
      // data.append("upload_preset", "ml_default");
      data.append("upload_preset", "priyabeads_image");
      data.append("cloud_name", cloud_name);
  
      const res = await 
      fetch(`https://api.cloudinary.com/v1_1/${cloud_name}/image/upload`, {
        method: "post",
        body: data,
      })
        
        const fileData=await res.json();
        console.log("url : ", fileData);
        return fileData.url
  
    } else {
      console.log("error");
    }
  };


// export const uploadToCloudinary = async (file: File) => {
//   const formData = new FormData();
//   formData.append("file", file);

//   const res = await fetch("http://localhost:5454/sellers/product/upload", {
//     method: "POST",
//     body: formData,
//   });

//   if (!res.ok) throw new Error("Upload failed");

//   const imagePath = await res.text();
//   return `http://localhost:5454${imagePath}`;
// };
